import { useEffect, useState } from 'react';

export const useCalculateTransitionStyle = (): string => {
  const [transition, setTransition] = useState(() => 'none');
  // устанавливаем анимацию transform после первого рендера
  useEffect(() => {
    const renderTimer = setTimeout(() => {
      setTransition('transform 0.45s linear');
    }, 100);

    return () => clearTimeout(renderTimer);
  }, []);
  return transition;
};
